import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Background3D from './ui/Background3D';
import { useTheme } from '../context/ThemeContext';
import { EmployeeProvider } from '../context/EmployeeContext';

const LayoutContent = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { sidebarCollapsed } = useTheme();

  return (
    <div className="min-h-screen relative transition-colors duration-300">
      <Background3D variant="layout" />

      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <div
        className={`
          relative z-10 transition-all duration-300 ease-in-out
          ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-72'}
        `}
      >
        <Header setSidebarOpen={setSidebarOpen} />

        <main className="p-4 md:p-6 lg:p-8 min-h-[calc(100vh-4rem)]">
          <div className="w-full page-container transition-all duration-300">
            <Outlet />
          </div>
        </main>
      </div>

      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

const Layout = () => (
  <EmployeeProvider>
    <LayoutContent />
  </EmployeeProvider>
);

export default Layout;
